import React from 'react';

export const CustomHeaderCheckbox = ({ checked, indeterminate, onSelectAll }) => {
    return (
        <div title={checked ? 'Uncheck All' : 'Select All'} style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '16px',
            height: '16px',
            border: '1px solid #a5a5a5',
            borderRadius: '2px',
            backgroundColor: indeterminate
                ? '#ffc107'
                : checked
                    ? '#007bff'
                    : 'white',
            cursor: 'pointer',
            userSelect: 'none',
            position: 'relative'
        }} onClick={() => onSelectAll(!checked)}>
            <span style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: '10px',
                color: indeterminate ? 'white' : 'white',
                content: indeterminate ? '\\2013' : '\\2714',
            }}></span>
        </div>
    );
};
